import rulesEng from './rulesContent/en.pdf';
import rulesEst from './rulesContent/est.pdf';
import rulesRus from './rulesContent/rus.pdf';




export default {
  termsAndConditions: [
    {
      'title': {
        'eng': 'Rules',
        'est': "Kliendi andmete töötlemise teabeleht",
        "rus": "Правила"
      },
      'hasSubTabs': false,
      'textTranslationKey': {
        'eng': `<div><embed src="${rulesEng}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
        'est': `<div><embed src="${rulesEst}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
        'rus': `<div><embed src="${rulesRus}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
      }
    }
  ]
};
